import { ConferenceControllerRedirect } from '@/imports/ui/pages/events/ConferenceControllerRedirect';

export default ConferenceControllerRedirect;
